module.exports = __webpack_public_path__ + "img/Assistant.2a265694.png";